export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_06.5144d360.mp4";